import React, { Component } from 'react';
import { connect } from 'react-redux';
import hexRgb from 'hex-rgb';
import { ICustomizationQuestion } from '../../store/slices/customization/customization';

interface Props {
  foregroundColor: string;
  question: ICustomizationQuestion;
}

class QuestionHeaderStyle extends Component<Props> {
  render() {
    const { foregroundColor, question } = this.props;
    const { align: questionAlignment = 'left', color: questionColor, font: questionFont } = question;
    const [fgRed, fgGreen, fbBlue] = hexRgb(foregroundColor, { format: 'array' });
    return (
      <style type="text/css" scoped>
        {`
          .survey .question-header {
            color: ${questionColor};
            font-family: ${questionFont};
            text-align: ${questionAlignment};
          }
          .survey .question-header p {
            color: ${questionColor};
            font-family: ${questionFont};
            text-align: ${questionAlignment};
          }
          .survey .question-header .number, .survey .question-header.is-sticky .number, .survey .heatmapInstructions .number {
            background-color: ${foregroundColor};
          }
          .survey .question-header .simple-checkbox:focus {
            border-color: ${foregroundColor};
            box-shadow: 0 0 0 4px rgba(${fgRed}, ${fgGreen}, ${fbBlue}, 0.45);
          }
        `}
      </style>
    );
  }
}

const mapStateToProps = (state) => {
  const { customization } = state;
  return {
    foregroundColor: customization.foregroundColor,
    question: customization.question,
  };
};

export default connect(mapStateToProps)(QuestionHeaderStyle);
